import React from 'react';
import { useSelector } from 'react-redux';
import ConnectionError from '@gameday/components/ConnectionError/ConnectionError';
import { getConnectionErrorState } from '../store/selectors/getConnectionError';

const ConnectionErrorContainer = () => {
    const { errorStatus } = useSelector(getConnectionErrorState);

    return (
        <ConnectionError
            errorStatus={errorStatus}
        />
    );
};

export default ConnectionErrorContainer;
